module.exports = __webpack_public_path__ + "static/media/img_Benchmarking301.4e920324.png";